import { useState, useEffect } from "react";
import {
  CommonText,
  CommonColorButton,
  CommonWhButton,
} from "../styledComponent/common";
import {
  ModalButtonSection,
  PreviewPopup,
} from "../styledComponent/campaignList";
import { PreviewContainer, CrossIcon } from "../styledComponent/baseListVIew";
import ButtonTextLoader from "../utils/Loader/ButtonTextLoader";
import crossBlack from "../assets/icons/cross_black.svg";

const DeletePopup = ({ type, isOpen, toggle, isDeleteLoading, onDelete }) => {
  const onPopupClick = (e) => {
    e.stopPropagation();
  };

  return (
    <PreviewContainer onClick={toggle}>
      <PreviewPopup>
        <div
          style={{ padding: `35px 30px 15px` }}
          onClick={(e) => onPopupClick(e)}
        >
          <div>
            <CommonText fontSize="16px" name="true">
              Are you sure you want to delete {type}?
            </CommonText>
          </div>
          <ModalButtonSection>
            <CommonWhButton padding="11px 35px" onClick={toggle}>
              Cancel
            </CommonWhButton>
            <CommonColorButton
              padding="11px 40px"
              bgColor="#FE5969"
              onClick={onDelete}
            >
              {isDeleteLoading ? (
                <ButtonTextLoader loadingText="Deleting" fontSize="14px" />
              ) : (
                "Delete"
              )}
            </CommonColorButton>
          </ModalButtonSection>
        </div>
        <CrossIcon>
          <img src={crossBlack} alt="cross-icon" width="100%" />
        </CrossIcon>
      </PreviewPopup>
    </PreviewContainer>
  );
};

export default DeletePopup;
